export const version = '0.0.1';
export const navbarBreakPoint = 'xl'; // Vertical navbar breakpoint
export const topNavbarBreakpoint = 'lg';
export const authAppMetadataKey = process.env.REACT_APP_AUTH_APP_METADATA_KEY || 'https://40baskets.com/';
export const maxResults = 100;
